export const DEFAULT_SEARCH_RADIUS = 25000; // 25km
